
import Model from './Model'

export default class Modifier extends Model {
  constructor (attributes = {}) {
    super(attributes.id)
    this.active = Boolean(attributes.active ?? 1) // TINYINT
    this.cookDuration = attributes.cookDuration // INT
    this.order = attributes.order // INT
    this.price = parseFloat(attributes.price) // DECIMAL 8,2
    this.autoSelected = Boolean(attributes.autoSelected ?? 0) // TINYINT
    this.category_id = attributes.category_id // INT
    this.photo = attributes.photo ?? null // VARCHAR 255
    this.negationType = attributes.negationType ?? 0 // TINYINT
    this.name = attributes.name // VARCHAR 255
  }
}
